import { actionTypePatient } from "../types";
import { ApiService } from "../../config";
import { Commons } from "../../utilities";

export const getAppointments =
    (
        pageSize,
        currentPage,
        search,
        sortExp,
        sortDir,
        patientGuid,
        doctorGuid,
        appointmentStatuses,
        fromDate,
        toDate,
        isRequiredRefundData,
        IsRequiredCommissionData,
        UserCurrency,
        UserTimeZone,
        clinicGuid,
        isOwn,
        isAnother,
        LanguageId,
        appointmentTypes,
        isFromPatientDetailPage
    ) =>
        async (dispatch) => {
            dispatch({ type: actionTypePatient.GET_APPOINTMENTS_REQUEST });
            try {
                const queryParams = Commons.addQueryParameter({
                    pageSize,
                    currentPage,
                    search,
                    sortExp,
                    sortDir,
                    patientGuid,
                    doctorGuid,
                    appointmentStatuses,
                    fromDate,
                    toDate,
                    isRequiredRefundData,
                    IsRequiredCommissionData,
                    UserCurrency,
                    UserTimeZone,
                    clinicGuid,
                    isOwn,
                    isAnother,
                    LanguageId,
                    appointmentTypes,
                    isFromPatientDetailPage
                });
                const response = await ApiService.get(
                    `/patient/getappointments?${queryParams}`
                );
                const responsePayload = {
                    data: response.data,
                    status: response.status,
                };

                dispatch({
                    type: actionTypePatient.GET_APPOINTMENTS_SUCCESS,
                    payload: responsePayload,
                });
            } catch (error) {
                const errorPayload = {
                    status: error.response?.status,
                    data: error.response?.data,
                };

                dispatch({
                    type: actionTypePatient.GET_APPOINTMENTS_FAILURE,
                    payload: errorPayload,
                });
            }
        };

export const clearAppointmentsData = () => ({
    type: actionTypePatient.CLEAR_APPOINTMENTS_DATA,
});

export const getClinicUpcomingAppointments =
    (
        pageSize,
        currentPage,
        search,
        sortExp,
        sortDir,
        patientGuid,
        doctorGuid,
        appointmentStatuses,
        fromDate,
        toDate,
        isRequiredRefundData,
        IsRequiredCommissionData,
        UserCurrency,
        UserTimeZone,
        clinicGuid,
        isOwn,
        isAnother,
        LanguageId,
        appointmentTypes
    ) =>
        async (dispatch) => {
            dispatch({
                type: actionTypePatient.GET_CLINIC_UPCOMING_APPOINTMENTS_REQUEST,
            });
            try {
                const queryParams = Commons.addQueryParameter({
                    pageSize,
                    currentPage,
                    search,
                    sortExp,
                    sortDir,
                    patientGuid,
                    doctorGuid,
                    appointmentStatuses,
                    fromDate,
                    toDate,
                    isRequiredRefundData,
                    IsRequiredCommissionData,
                    UserCurrency,
                    UserTimeZone,
                    clinicGuid,
                    isOwn,
                    isAnother,
                    LanguageId,
                    appointmentTypes,
                });
                const response = await ApiService.get(
                    `/patient/getappointments?${queryParams}`
                );
                const responsePayload = {
                    data: response.data,
                    status: response.status,
                };

                dispatch({
                    type: actionTypePatient.GET_CLINIC_UPCOMING_APPOINTMENTS_SUCCESS,
                    payload: responsePayload,
                });
            } catch (error) {
                const errorPayload = {
                    status: error.response?.status,
                    data: error.response?.data,
                };

                dispatch({
                    type: actionTypePatient.GET_CLINIC_UPCOMING_APPOINTMENTS_FAILURE,
                    payload: errorPayload,
                });
            }
        };

export const getRequestedAppointments =
    (
        pageSize,
        currentPage,
        search,
        sortExp,
        sortDir,
        patientGuid,
        doctorGuid,
        appointmentStatuses,
        fromDate,
        toDate,
        isRequiredRefundData,
        IsRequiredCommissionData,
        UserCurrency,
        UserTimeZone,
        clinicGuid,
        isOwn,
        isAnother,
        LanguageId,
        appointmentTypes
    ) =>
        async (dispatch) => {
            dispatch({ type: actionTypePatient.GET_REQUESTED_APPOINTMENTS_REQUEST });
            try {
                const queryParams = Commons.addQueryParameter({
                    pageSize,
                    currentPage,
                    search,
                    sortExp,
                    sortDir,
                    patientGuid,
                    doctorGuid,
                    appointmentStatuses,
                    fromDate,
                    toDate,
                    isRequiredRefundData,
                    IsRequiredCommissionData,
                    UserCurrency,
                    UserTimeZone,
                    clinicGuid,
                    isOwn,
                    isAnother,
                    LanguageId,
                    appointmentTypes,
                });
                const response = await ApiService.get(
                    `/patient/getappointments?${queryParams}`
                );
                const responsePayload = {
                    data: response.data,
                    status: response.status,
                };

                dispatch({
                    type: actionTypePatient.GET_REQUESTED_APPOINTMENTS_SUCCESS,
                    payload: responsePayload,
                });
            } catch (error) {
                const errorPayload = {
                    status: error.response?.status,
                    data: error.response?.data,
                };

                dispatch({
                    type: actionTypePatient.GET_REQUESTED_APPOINTMENTS_FAILURE,
                    payload: errorPayload,
                });
            }
        };

export const getClinicRequestedAppointments =
    (
        pageSize,
        currentPage,
        search,
        sortExp,
        sortDir,
        patientGuid,
        doctorGuid,
        appointmentStatuses,
        fromDate,
        toDate,
        isRequiredRefundData,
        IsRequiredCommissionData,
        UserCurrency,
        UserTimeZone,
        clinicGuid,
        isOwn,
        isAnother,
        LanguageId,
        appointmentTypes
    ) =>
        async (dispatch) => {
            dispatch({
                type: actionTypePatient.GET_CLINIC_REQUESTED_APPOINTMENTS_REQUEST,
            });
            try {
                const queryParams = Commons.addQueryParameter({
                    pageSize,
                    currentPage,
                    search,
                    sortExp,
                    sortDir,
                    patientGuid,
                    doctorGuid,
                    appointmentStatuses,
                    fromDate,
                    toDate,
                    isRequiredRefundData,
                    IsRequiredCommissionData,
                    UserCurrency,
                    UserTimeZone,
                    clinicGuid,
                    isOwn,
                    isAnother,
                    LanguageId,
                    appointmentTypes,
                });
                const response = await ApiService.get(
                    `/patient/getappointments?${queryParams}`
                );
                const responsePayload = {
                    data: response.data,
                    status: response.status,
                };

                dispatch({
                    type: actionTypePatient.GET_CLINIC_REQUESTED_APPOINTMENTS_SUCCESS,
                    payload: responsePayload,
                });
            } catch (error) {
                const errorPayload = {
                    status: error.response?.status,
                    data: error.response?.data,
                };

                dispatch({
                    type: actionTypePatient.GET_CLINIC_REQUESTED_APPOINTMENTS_FAILURE,
                    payload: errorPayload,
                });
            }
        };

export const postSearchDoctorAppointment =
    (credentials, doctorGuid) => async (dispatch) => {
        dispatch({
            type: actionTypePatient.POST_SEARCH_DOCTOR_APPOINTMENT_REQUEST,
        });
        try {
            const response = await ApiService.post(
                `/patient/searchdoctorappointment?doctorGuid=${doctorGuid}`,
                JSON.stringify(credentials)
            );

            const responsePayload = {
                data: response.data,
                status: response.status,
            };

            dispatch({
                type: actionTypePatient.POST_SEARCH_DOCTOR_APPOINTMENT_SUCCESS,
                payload: responsePayload,
            });
        } catch (error) {
            const errorPayload = {
                status: error.response?.status,
                data: error.response?.data,
            };

            dispatch({
                type: actionTypePatient.POST_SEARCH_DOCTOR_APPOINTMENT_FAILURE,
                payload: errorPayload,
            });
        }
    };

export const getUserTypeAppointment =
    (LoginDoctorGuid, ExternalUser) => async (dispatch) => {
        dispatch({ type: actionTypePatient.GET_USER_TYPE_APPOINTMENT_REQUEST });
        try {
            const queryParams = Commons.addQueryParameter({
                LoginDoctorGuid,
                ExternalUser,
            });
            const response = await ApiService.get(
                `/patient/getusertypeappointment?${queryParams}`
            );
            const responsePayload = {
                data: response.data,
                status: response.status,
            };

            dispatch({
                type: actionTypePatient.GET_USER_TYPE_APPOINTMENT_SUCCESS,
                payload: responsePayload,
            });
        } catch (error) {
            const errorPayload = {
                status: error.response?.status,
                data: error.response?.data,
            };

            dispatch({
                type: actionTypePatient.GET_USER_TYPE_APPOINTMENT_FAILURE,
                payload: errorPayload,
            });
        }
    };

export const postAllAvailability =
    (credentials, doctorGuid) => async (dispatch) => {
        dispatch({ type: actionTypePatient.POST_ALL_AVAILABILITY_REQUEST });
        try {
            const queryParams = Commons.addQueryParameter({ doctorGuid });
            const response = await ApiService.post(
                `/patient/allavailability?${queryParams}`,
                JSON.stringify(credentials)
            );
            const responsePayload = {
                data: response.data,
                status: response.status,
            };

            dispatch({
                type: actionTypePatient.POST_ALL_AVAILABILITY_SUCCESS,
                payload: responsePayload,
            });
        } catch (error) {
            const errorPayload = {
                status: error.response?.status,
                data: error.response?.data,
            };

            dispatch({
                type: actionTypePatient.POST_ALL_AVAILABILITY_FAILURE,
                payload: errorPayload,
            });
        }
    };

export const getSelectedUserDetails = (userGuid) => async (dispatch) => {
    dispatch({ type: actionTypePatient.GET_SELECTED_USER_DETAILS_REQUEST });
    try {
        const response = await ApiService.get(
            `/patient/getselecteduserdetails?userGuid=${userGuid}`
        );

        const responsePayload = {
            data: response.data,
            status: response.status,
        };

        dispatch({
            type: actionTypePatient.GET_SELECTED_USER_DETAILS_SUCCESS,
            payload: responsePayload,
        });
    } catch (error) {
        const errorPayload = {
            status: error.response?.status,
            data: error.response?.data,
        };

        dispatch({
            type: actionTypePatient.GET_SELECTED_USER_DETAILS_FAILURE,
            payload: errorPayload,
        });
    }
};

export const postBookOfflineAppointment =
    (credentials, callback) => async (dispatch) => {
        dispatch({ type: actionTypePatient.POST_BOOK_OFFLINE_APPOINTMENT_REQUEST });
        try {
            const response = await ApiService.post(
                "/patient/bookofflineappointment",
                JSON.stringify(credentials)
            );
            dispatch({
                type: actionTypePatient.POST_BOOK_OFFLINE_APPOINTMENT_SUCCESS,
                payload: response,
            });
            if (callback) {
                callback(null, response);
            }
        } catch (error) {
            dispatch({
                type: actionTypePatient.POST_BOOK_OFFLINE_APPOINTMENT_FAILURE,
                payload: error,
            });
            if (callback) {
                callback(error.response, null);
            }
        }
    };

export const postUploadDocument =
    (documentType, referenceGuid, formData, callback) => async (dispatch) => {
        dispatch({ type: actionTypePatient.POST_UPLOAD_DOCUMENT_REQUEST });
        try {
            const response = await ApiService.post(
                `/api/UploadDocument?documentType=${documentType}&referenceGuid=${referenceGuid}`,
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            );
            dispatch({
                type: actionTypePatient.POST_UPLOAD_DOCUMENT_SUCCESS,
                payload: response,
            });
            if (callback) {
                callback(null, response);
            }
        } catch (error) {
            dispatch({
                type: actionTypePatient.POST_UPLOAD_DOCUMENT_FAILURE,
                payload: error,
            });
            if (callback) {
                callback(error.response, null);
            }
        }
    };

export const postAppointmentStatus =
    (appointmentGuid, isConfirm, callback) => async (dispatch) => {
        dispatch({ type: actionTypePatient.POST_APPOINTMENT_STATUS_REQUEST });
        try {
            const queryParams = Commons.addQueryParameter({
                appointmentGuid,
                isConfirm,
            });
            const response = await ApiService.post(
                `/patient/appointmentstatus?${queryParams}`
            );
            dispatch({
                type: actionTypePatient.POST_APPOINTMENT_STATUS_SUCCESS,
                payload: response,
            });
            if (callback) {
                callback(null, response);
            }
        } catch (error) {
            dispatch({
                type: actionTypePatient.POST_APPOINTMENT_STATUS_FAILURE,
                payload: error,
            });
            if (callback) {
                callback(error.response, null);
            }
        }
    };

export const postBookedAppointment =
    (credentials, callback) => async (dispatch) => {
        dispatch({ type: actionTypePatient.POST_BOOKED_APPOINTMENT_REQUEST });
        try {
            const response = await ApiService.post(
                "patient/bookedappointment",
                JSON.stringify(credentials)
            );
            dispatch({
                type: actionTypePatient.POST_BOOKED_APPOINTMENT_SUCCESS,
                payload: response,
            });
            if (callback) {
                callback(null, response);
            }
        } catch (error) {
            dispatch({
                type: actionTypePatient.POST_BOOKED_APPOINTMENT_FAILURE,
                payload: error,
            });
            if (callback) {
                callback(error.response, null);
            }
        }
    };

export const postCancelAppointment =
    (appointmentGuid, cancelReason, canceledBy, suggestedDateTime, callback) =>
        async (dispatch) => {
            dispatch({ type: actionTypePatient.POST_CANCEL_APPOINTMENT_REQUEST });
            try {
                const queryParams = Commons.addQueryParameter({
                    appointmentGuid,
                    cancelReason,
                    canceledBy,
                    suggestedDateTime,
                });
                const response = await ApiService.post(
                    `/patient/cancelappointment?${queryParams}`
                );
                dispatch({
                    type: actionTypePatient.POST_CANCEL_APPOINTMENT_SUCCESS,
                    payload: response,
                });
                if (callback) {
                    callback(null, response);
                }
            } catch (error) {
                dispatch({
                    type: actionTypePatient.POST_CANCEL_APPOINTMENT_FAILURE,
                    payload: error,
                });
                if (callback) {
                    callback(error.response, null);
                }
            }
        };

export const getQuestion = (pageNo, lang) => async (dispatch) => {
    dispatch({ type: actionTypePatient.GET_QUESTION_REQUEST });
    try {
        const queryParams = Commons.addQueryParameter({ pageNo, lang });
        const response = await ApiService.get(`/patient/question?${queryParams}`);

        const responsePayload = {
            data: response.data,
            status: response.status,
        };

        dispatch({
            type: actionTypePatient.GET_QUESTION_SUCCESS,
            payload: responsePayload,
        });
    } catch (error) {
        const errorPayload = {
            status: error.response?.status,
            data: error.response?.data,
        };

        dispatch({
            type: actionTypePatient.GET_QUESTION_FAILURE,
            payload: errorPayload,
        });
    }
};

export const getAnswers = (patientGuid, pageNo) => async (dispatch) => {
    dispatch({ type: actionTypePatient.GET_ANSWERS_REQUEST });
    try {
        const queryParams = Commons.addQueryParameter({ patientGuid, pageNo });
        const response = await ApiService.get(`/patient/answers?${queryParams}`);

        const responsePayload = {
            data: response.data,
            status: response.status,
        };

        dispatch({
            type: actionTypePatient.GET_ANSWERS_SUCCESS,
            payload: responsePayload,
        });
    } catch (error) {
        const errorPayload = {
            status: error.response?.status,
            data: error.response?.data,
        };

        dispatch({
            type: actionTypePatient.GET_ANSWERS_FAILURE,
            payload: errorPayload,
        });
    }
};

export const getPatientById = (patientGuid) => async (dispatch) => {
    dispatch({ type: actionTypePatient.GET_PATIENT_BY_ID_REQUEST });
    try {
        const queryParams = Commons.addQueryParameter({ patientGuid });
        const response = await ApiService.get(
            `/patient/getpatientbyid?${queryParams}`
        );

        const responsePayload = {
            data: response.data,
            status: response.status,
        };

        dispatch({
            type: actionTypePatient.GET_PATIENT_BY_ID_SUCCESS,
            payload: responsePayload,
        });
    } catch (error) {
        const errorPayload = {
            status: error.response?.status,
            data: error.response?.data,
        };

        dispatch({
            type: actionTypePatient.GET_PATIENT_BY_ID_FAILURE,
            payload: errorPayload,
        });
    }
};

export const postSavePatientDetail =
    (credentials, callback) => async (dispatch) => {
        dispatch({ type: actionTypePatient.POST_SAVE_PATIENT_DETAIL_REQUEST });
        try {
            const response = await ApiService.post(
                "patient/savepatientdetail",
                JSON.stringify(credentials)
            );
            dispatch({
                type: actionTypePatient.POST_SAVE_PATIENT_DETAIL_SUCCESS,
                payload: response,
            });
            if (callback) {
                callback(null, response);
            }
        } catch (error) {
            dispatch({
                type: actionTypePatient.POST_SAVE_PATIENT_DETAIL_FAILURE,
                payload: error,
            });
            if (callback) {
                callback(error.response, null);
            }
        }
    };

export const getBookedChatDetails =
    (credentials, callback) => async (dispatch) => {
        dispatch({ type: actionTypePatient.GET_BOOKED_CHAT_DETAILS_REQUEST });
        try {
            const response = await ApiService.post(
                "patient/getBookedChatDetails",
                JSON.stringify(credentials)
            );
            const responsePayload = {
                data: response.data,
                status: response.status,
            };

            dispatch({
                type: actionTypePatient.GET_BOOKED_CHAT_DETAILS_SUCCESS,
                payload: responsePayload,
            });
            if (callback) {
                callback(null, response);
            }
        } catch (error) {
            const errorPayload = {
                status: error.response?.status,
                data: error.response?.data,
            };

            dispatch({
                type: actionTypePatient.GET_BOOKED_CHAT_DETAILS_FAILURE,
                payload: errorPayload,
            });
            if (callback) {
                callback(error.response, null);
            }
        }
    };

export const postFetchNextAppointments = (credentials, doctorGuid, isViewAllAvailability, callback) => async (dispatch) => {
    dispatch({ type: actionTypePatient.POST_FETCH_NEXT_APPOINTMENTS_REQUEST });
    try {
        const queryParams = Commons.addQueryParameter({ doctorGuid, isViewAllAvailability });
        const response = await ApiService.post(
            `/patient/fetchnextappointments?${queryParams}`,
            JSON.stringify(credentials)
        );
        dispatch({
            type: actionTypePatient.POST_FETCH_NEXT_APPOINTMENTS_SUCCESS,
            payload: response,
        });
        if (callback) {
            callback(null, response);
        }
    } catch (error) {
        dispatch({
            type: actionTypePatient.POST_FETCH_NEXT_APPOINTMENTS_FAILURE,
            payload: error,
        });
        if (callback) {
            callback(error.response, null);
        }
    }
}


export const postGetEmergencyCallByPatient =
    (credentials) => async (dispatch) => {
        dispatch({ type: actionTypePatient.POST_GET_EMERGENCY_CALL_BY_PATIENT_REQUEST });
        try {
            const response = await ApiService.post(
                "/patient/getEmergencyCallByPatient",
                JSON.stringify(credentials)
            );
            const responsePayload = {
                data: response.data,
                status: response.status,
            };

            dispatch({
                type: actionTypePatient.POST_GET_EMERGENCY_CALL_BY_PATIENT_SUCCESS,
                payload: responsePayload,
            });

        } catch (error) {
            const errorPayload = {
                status: error.response?.status,
                data: error.response?.data,
            };

            dispatch({
                type: actionTypePatient.POST_GET_EMERGENCY_CALL_BY_PATIENT_FAILURE,
                payload: errorPayload,
            });

        }
    };

export const postGetChatAppointmentByPatient =
    (credentials) => async (dispatch) => {
        dispatch({ type: actionTypePatient.POST_GET_CHAT_APPOINTMENT_BY_PATIENT_REQUEST });
        try {
            const response = await ApiService.post(
                "/patient/getChatAppointmentByPatient",
                JSON.stringify(credentials)
            );
            const responsePayload = {
                data: response.data,
                status: response.status,
            };
            dispatch({
                type: actionTypePatient.POST_GET_CHAT_APPOINTMENT_BY_PATIENT_SUCCESS,
                payload: responsePayload,
            });
        } catch (error) {
            const errorPayload = {
                status: error.response?.status,
                data: error.response?.data,
            };

            dispatch({
                type: actionTypePatient.POST_GET_CHAT_APPOINTMENT_BY_PATIENT_FAILURE,
                payload: errorPayload,
            });
        }
    };

const actionPatient = {
    getAppointments,
    clearAppointmentsData,
    getClinicUpcomingAppointments,
    getRequestedAppointments,
    getClinicRequestedAppointments,
    postSearchDoctorAppointment,
    getUserTypeAppointment,
    postAllAvailability,
    getSelectedUserDetails,
    postBookOfflineAppointment,
    postUploadDocument,
    postAppointmentStatus,
    postBookedAppointment,
    postCancelAppointment,
    getQuestion,
    getAnswers,
    getPatientById,
    postSavePatientDetail,
    getBookedChatDetails,
    postFetchNextAppointments,
    postGetEmergencyCallByPatient,
    postGetChatAppointmentByPatient
};
export default actionPatient;
